// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"styles__container___1uULS"};
    if(module.hot) {
      // 1765762391077
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  